import { openModal } from '../helpers/modals.js';

const selectors = {
  toggleModal: '[data-toggle-modal]',
};

/**
 * Initializes all modals on the page that have the data-modal attribute
 * @param {HTMLElement} [container=document] - Optional container to limit modal initialization scope
 * @returns {Function} Function to cleanup observer and modals
 *
 * Emits:
 *   'modal:opened' (CustomEvent) on the modal element when opened. Event detail contains { id: modalId }
 *   'modal:closed' (CustomEvent) on the modal element when closed. Event detail contains { id: modalId }
 *
 * Behavior:
 *   - Clicking the modal backdrop (outside modal content) will close the modal.
 */
export default function initModals() {
  const toggles = document.querySelectorAll(selectors.toggleModal);

  if (!toggles.length) {
    return;
  }

  toggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault();
      const modalId = toggle.getAttribute('data-toggle-modal');
      openModal(modalId);
    });
  });
}
